import React from 'react';
import NovaeonMark from '../logo/logo';
import ThemeToggle from '../themeToggle/themeToggle';
import { styles } from './styles';

// Chrome shared by the standalone document pages — /legal and the 404. Header (brand, theme
// toggle, close), the narrow reading column, and the footer from public/privacy.html.
//
// These pages deliberately do NOT use Bookend: its nav scrolls to #services / #products,
// sections that do not exist here, and its footer links do the same.
interface DocumentPageProps {
  children: React.ReactNode;
  // Both default to on. The 404 turns them off: it already carries its own "Go to novaeon.io"
  // link in the body, and three ways home on one short page is noise, not helpfulness.
  showClose?: boolean;
  showBackLink?: boolean;
}

const DocumentPage: React.FC<DocumentPageProps> = ({
  children,
  showClose = true,
  showBackLink = true,
}) => {

  // privacy.html's close affordance: back to wherever the visitor came from, else the home
  // page. Someone arriving from the app has no history to go back to.
  const close = () => {
    if (window.history.length > 1) { window.history.back(); }
    else { window.location.href = '/'; }
  };

  return (
    <div className="document-wrap" style={styles.page}>
      <header style={styles.header}>
        <a href="/" style={styles.brand} aria-label="Novaeon home">
          <NovaeonMark size={30} />
          <span style={styles.wordmark}>Novaeon</span>
        </a>
        <div style={styles.headerActions}>
          <ThemeToggle />
          {showClose && (
            <button style={styles.closeButton} onClick={close} aria-label="Back to novaeon.io">
              <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round">
                <path d="M6 6l12 12M18 6L6 18" />
              </svg>
            </button>
          )}
        </div>
      </header>

      {children}

      <footer style={styles.footer}>
        <span style={styles.footerCopy}>
          © {new Date().getFullYear()} Novaeon LLC. All rights reserved.
        </span>
        {showBackLink && <a href="/" style={styles.footerBack}>← Back to novaeon.io</a>}
      </footer>
    </div>
  );
};

export default DocumentPage;
